/**
 * 枚举字典定义
 */

// 物品名称枚举
export const GOODS_NAME = {
  FLOWER: { value: 'flower', label: '鲜花', tagType: 'primary' },
  VEGETABLE: { value: 'vegetable', label: '蔬菜', tagType: 'warning' },
  EXPRESS: { value: 'penhua', label: '盆花', tagType: 'danger' },
}

// 账单状态枚举
export const BILL_STATUS = {
  FINISH: { value: 'TO_BE_PAY', label: '待支付 ', tagType: 'warning' },
  CANCELED: { value: 'FINISH', label: '已支付', tagType: 'success' },
}

// 货物运输方式枚举
export const DELIVERY_TYPE = {
  AIR: { value: 'plane', label: '空运', tagType: 'primary' },
  GROUND: { value: 'land', label: '冷链', tagType: 'warning' },
}

/**
 * 根据值获取枚举项
 * @param {Object} dict - 枚举字典
 * @param {String} value - 枚举值
 * @param {Object} defaultItem - 默认返回值，找不到时返回
 * @returns {Object} 枚举项
 */
export function getDictItem(dict, value, defaultItem = { label: '未知', tagType: 'default' }) {
  // 如果value为空，返回默认值
  if (value === undefined || value === null || value === '') {
    return defaultItem
  }
  
  // 查找匹配的枚举项
  for (const key in dict) {
    if (dict[key].value === value) {
      return dict[key]
    }
  }
  
  // 未找到匹配项，返回默认值
  return {
    value,
    ...defaultItem
  }
}

/**
 * 获取枚举标签
 * @param {Object} dict - 枚举字典
 * @param {String} value - 枚举值
 * @returns {String} 标签文本
 */
export function getDictLabel(dict, value) {
  return getDictItem(dict, value).label
}

/**
 * 获取枚举标签类型
 * @param {Object} dict - 枚举字典
 * @param {String} value - 枚举值
 * @returns {String} 标签类型
 */
export function getDictTagType(dict, value) {
  return getDictItem(dict, value).tagType
}

/**
 * 获取字典选项数组，用于下拉选择
 * @param {Object} dict - 枚举字典
 * @returns {Array} 选项数组
 */
export function getDictOptions(dict) {
  return Object.values(dict).map(item => ({
    value: item.value,
    label: item.label
  }))
} 